import Vue from 'vue';

import WApp from "@/components/WApp.vue";
import WBtnIcon from "@/components/WBtnIcon.vue";
import WBtn from "@/components/WBtn.vue";
import WBtnPrint from "@/components/WBtnPrint.vue";
import WBtnPrevious from "@/components/WBtnPrevious.vue";
import WBtnNext from "@/components/WBtnNext.vue";
import WBtnActivate from "@/components/WBtnActivate.vue";
import WBtnDeactivate from "@/components/WBtnDeactivate.vue";
import WBtnApply from "@/components/WBtnApply.vue";
import WBtnAdd from "@/components/WBtnAdd.vue";
import WBtnUpdate from "@/components/WBtnUpdate.vue";
import WBtnDelete from "@/components/WBtnDelete.vue";
import WBtnClose from "@/components/WBtnClose.vue";
import WBtnUnlock from "@/components/WBtnUnlock.vue";
import WBtnLock from "@/components/WBtnLock.vue";
import WBtnReload from "@/components/WBtnReload.vue";
import WBtnExport from "@/components/WBtnExport.vue";
import WBtnImport from "@/components/WBtnImport.vue";
import WBtnArchive from "@/components/WBtnArchive.vue";
import WBtnUnarchive from "@/components/WBtnUnarchive.vue";
import WChip from "@/components/WChip.vue";
import WCityAutocomplete from "@/components/WCityAutocomplete.vue";
import WCodeGeneration from "@/components/WCodeGeneration.vue";
import WColorPicker from "@/components/WColorPicker.vue";
import WDataSelectAutocomplete from "@/components/WDataSelectAutocomplete.vue";
import WDatePicker from "@/components/WDatePicker.vue";
import WDialogToolbar from "@/components/WDialogToolbar.vue";
import WEnumSelect from "@/components/WEnumSelect.vue";
import WFieldset from "@/components/WFieldset.vue";
import WFileInput from "@/components/WFileInput.vue";
import WMonthPicker from "@/components/WMonthPicker.vue";
import WOverlay from "@/components/WOverlay.vue";
import WServerAutocomplete from "@/components/WServerAutocomplete.vue";
import WSimpleTextArea from "@/components/WSimpleTextArea.vue";
import WStateAutocomplete from "@/components/WStateAutocomplete.vue";
import WTextArea from "@/components/WTextArea.vue";
import WTextField from "@/components/WTextField.vue";
import WTimePicker from "@/components/WTimePicker.vue";
import WVuetifyColorPicker from "@/components/WVuetifyColorPicker.vue";
import WUserAutocomplete from "@/components/WUserAutocomplete.vue";
import WServerDataTable from "@/components/WServerDataTable.vue";
import WDataTable from "@/components/WDataTable.vue";
import WRankSelect from "@/components/WRankSelect.vue"
import WYearOffsetAutocomplete from "@/components/WYearOffsetAutocomplete.vue"
import WLabel from "@/components/WLabel.vue"
import WToolbar from "@/components/WToolbar.vue"
import WInlineText from "@/components/WInlineText.vue"
import WEditDialog from "@/components/WEditDialog.vue"
import WPasswordTextField from "@/components/WPasswordTextField.vue"


// Register all W-prefixed components
Vue.component('w-app', WApp);
Vue.component('w-btn-icon', WBtnIcon);
Vue.component('w-btn', WBtn);
Vue.component('w-btn-print', WBtnPrint);
Vue.component('w-btn-previous', WBtnPrevious);
Vue.component('w-btn-next', WBtnNext);
Vue.component('w-btn-activate', WBtnActivate);
Vue.component('w-btn-deactivate', WBtnDeactivate);
Vue.component('w-btn-apply', WBtnApply);
Vue.component('w-btn-add', WBtnAdd);
Vue.component('w-btn-update', WBtnUpdate);
Vue.component('w-btn-delete', WBtnDelete);
Vue.component('w-btn-close', WBtnClose);
Vue.component('w-btn-unlock', WBtnUnlock);
Vue.component('w-btn-lock', WBtnLock);
Vue.component('w-btn-reload', WBtnReload);
Vue.component('w-btn-export', WBtnExport);
Vue.component('w-btn-import', WBtnImport);
Vue.component('w-btn-archive', WBtnArchive);
Vue.component('w-btn-unarchive', WBtnUnarchive);
Vue.component('w-chip', WChip);
Vue.component('w-city-autocomplete', WCityAutocomplete);
Vue.component('w-code-generation', WCodeGeneration);
Vue.component('w-color-picker', WColorPicker);
Vue.component('w-data-select-autocomplete', WDataSelectAutocomplete);
Vue.component('w-date-picker', WDatePicker);
Vue.component('w-dialog-toolbar', WDialogToolbar);
Vue.component('w-enum-select', WEnumSelect);
Vue.component('w-fieldset', WFieldset);
Vue.component('w-file-input', WFileInput);
Vue.component('w-month-picker', WMonthPicker);
Vue.component('w-overlay', WOverlay);
Vue.component('w-server-autocomplete', WServerAutocomplete);
Vue.component('w-simple-text-area', WSimpleTextArea);
Vue.component('w-state-autocomplete', WStateAutocomplete);
Vue.component('w-text-area', WTextArea);
Vue.component('w-text-field', WTextField);
Vue.component('w-time-picker', WTimePicker);
Vue.component('w-vuetify-color-picker', WVuetifyColorPicker);
Vue.component('w-user-autocomplete', WUserAutocomplete);
Vue.component('w-server-data-table', WServerDataTable);
Vue.component('w-data-table', WDataTable);
Vue.component('w-rank-select', WRankSelect);
Vue.component('w-year-offset-autocomplete', WYearOffsetAutocomplete);
Vue.component('w-label', WLabel);
Vue.component('w-toolbar', WToolbar);
Vue.component('w-inline-text', WInlineText);
Vue.component('w-edit-dialog', WEditDialog);
Vue.component('w-password-text-field', WPasswordTextField);